import { HeadSyncIcon } from './HeadSyncIcon';

/**
 * author: Michael Irigoyen
 * id CB0FD2AA-6EA8-4324-8207-6C4FFCCB5143
 * name head-sync
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-sync.svg
 * tags
 */
export const HeadReloadIcon = HeadSyncIcon;
export default HeadReloadIcon